import { useEffect, useState } from "react";
import { Outlet, useMatches, useNavigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

import Button from "@components/Button";
import PageTitle from "@components/PageTitle";

import PathContants from "@routers/pathConstants";
import "./style.scss";

type RouteHandle =
	| {
			title?: string;
	  }
	| undefined;
export default function SignupLayout() {
	const navigate = useNavigate();
	const matches = useMatches() as (RouteObject & { handle?: RouteHandle })[];
	const current = matches.find((m) => m.handle?.title);
	const [activeButton, setActiveButton] = useState<string>("");

	useEffect(() => {
		if (location.pathname === PathContants.AuthSignup) {
			setActiveButton(PathContants.AuthSignup);
		} else if (location.pathname === PathContants.AuthFindId) {
			setActiveButton(PathContants.AuthFindId);
		} else if (location.pathname === PathContants.AuthFindPassword) {
			setActiveButton(PathContants.AuthFindPassword);
		}
	}, [location.pathname]);

	const handleGoToSignup = () => {
		navigate(PathContants.AuthSignup);
		setActiveButton(PathContants.AuthSignup);
	};

	const handleGoToFindId = () => {
		navigate(PathContants.AuthFindId);
		setActiveButton(PathContants.AuthFindId);
	};

	const handleGoToFindPassword = () => {
		navigate(PathContants.AuthFindPassword);
		setActiveButton(PathContants.AuthFindPassword);
	};
	return (
		<div className="auth-layout">
			<PageTitle title={current?.handle?.title} />
			<div className="auth-layout__content">
				<div className="auth-layout__content-navigation">
					<Button
						label="회원가입"
						color={activeButton === PathContants.AuthSignup ? "white" : "black"}
						onClick={handleGoToSignup}
					/>
					<Button
						label="아이디 찾기"
						color={activeButton === PathContants.AuthFindId ? "white" : "black"}
						onClick={handleGoToFindId}
					/>
					<Button
						label="비밀번호 찾기"
						color={activeButton === PathContants.AuthFindPassword ? "white" : "black"}
						onClick={handleGoToFindPassword}
					/>
				</div>
				<Outlet />
			</div>
		</div>
	);
}
